<template>
  <el-dialog
    title="扣资"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form label-width="120px" :model="editForm" ref="editForm">
      <el-row>
        <el-form-item label="票号">
          <el-input
            size="small"
            v-model="editForm.moneyOrderCode"
            auto-complete="off"
            placeholder="票号"
            disabled
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="进价（%）">
          <el-input
            size="small"
            v-model="editForm.inPercentage"
            auto-complete="off"
            placeholder="进价（%）"
            disabled
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="扣资（%）">
          <el-input
            size="small"
            v-model="editForm.deductionPrice"
            auto-complete="off"
            placeholder="扣资（%）"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { saveOrUpdateCheck } from "@/api/ticket/check";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.editForm.inPercentage) {
            saveOrUpdateCheck(this.editForm)
              .then(() => {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$emit("confirm");
                this.handleClose();
              })
              .catch((err) => {
                this.$message({
                  message: err.message,
                  type: "error",
                });
              });
          } else {
            this.$message.warning("进价不能为空");
          }
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-check-rollback/payment.vue